"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _HelpOutline = _interopRequireDefault(require("@rsuite/icon-font/lib/status/HelpOutline"));

// Generated by script, don't edit it please.
var HelpOutline = (0, _createSvgIcon["default"])({
  as: _HelpOutline["default"],
  ariaLabel: 'help outline',
  category: 'status',
  displayName: 'HelpOutline'
});
var _default = HelpOutline;
exports["default"] = _default;
module.exports = exports.default;